import React from "react";
import {configIsExist, setConfigs} from "./functions";

import {connect} from "react-redux";

class RestrictedHidden extends React.Component {

    render() {
        var type = "CONFIG"
        if (this.props.type) {
            type = this.props.type
        }
        var showOnTrue = true
        if (this.props.showOnTrue) {
            showOnTrue = this.props.showOnTrue
        }

        var result
        if (typeof this.props.condition == "boolean") {
            result = this.props.condition
        } else {
            result = configIsExist(this.props.condition, type)
        }

        if (showOnTrue && result) {
            return this.props.children
        }

        if (!showOnTrue && !result) {
            return this.props.children
        }

        return (null)
    }
}

const mapStateToProps = (state => {
    const configs = [...state.auth.org.configs || []]
    return {
        configs: configs
    }
})

export default connect(mapStateToProps)(RestrictedHidden)
